import { Crown } from "lucide-react";

/**
 * Small "Founder" badge shown next to a user's name across the app.
 * Renders only when `user` has founder tier OR the Founder Member badge.
 *
 * Release 1.2-P3-B: the founder-detection rule matches the canonical
 * `isFounder` derivation in AuthContext:
 *   founder = (active && tier === "founder") || has "Founder Member" badge
 * Do NOT diverge from AuthContext.deriveFlags without updating both.
 *
 * Props:
 *   user: user object (from useAuth or API rows)
 *   size: "sm" (default) | "xs" | "md"
 *   showLabel: boolean — whether to render the word "Founder" (defaults true)
 */
export default function FounderBadge({ user, size = "sm", showLabel = true, className = "" }) {
  if (!user) return null;
  const isFounder =
    (!!user.subscription_active && user.subscription_tier === "founder") ||
    (Array.isArray(user.badges) && user.badges.includes("Founder Member"));
  if (!isFounder) return null;

  const px = size === "xs" ? "px-1.5 py-0.5 text-[9px]"
    : size === "md" ? "px-2.5 py-1 text-xs"
    : "px-2 py-0.5 text-[10px]";
  const iconSize = size === "xs" ? 9 : size === "md" ? 13 : 11;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-bold uppercase tracking-[0.14em]
                  bg-amber-500/15 text-amber-700 dark:text-amber-300 border border-amber-500/40 ${px} ${className}`}
      title="SparkRead Founder Member"
      data-testid="founder-badge"
    >
      <Crown size={iconSize} className="fill-amber-500 stroke-amber-600" />
      {showLabel && <span>Founder</span>}
    </span>
  );
}
